<hdi-stage
  [caasData]="caasData"
  [breadcrumbs]="breadcrumbs"
  [newsComponent]="newsComponent"
  [news]="news"
  [newsFilters]="newsFilters"
  [filteredNews]="filteredNews"
  [inpageMenu]="inpageMenu"
  (updateNews)="updateNews($event)"
></hdi-stage>

<ng-container *ngIf="mainSections">
  <hdi-section
    *ngFor="let section of mainSections; let i = index"
    [backgroundColor]="alternateBackground[i]"
    [mainSection]="section"
    [podcastData]="podcastData"
    [news]="news"
    [tags]="tags"
    [eventsData]="events"
    [newsFilters]="newsFilters"
    [imagesMetaData]="imagesMetaData"
    [id]="i.toString()"
  >
  </hdi-section>
</ng-container>

<hdi-modal
  [showModal]="showModal"
  [type]="ModalType.VIDEO"
  [videoSrc]="videoSrc ?? ''"
  [videoId]="videoId ?? ''"
  [thumbnailSrc]="''"
  (closeModalTrigger)="showModal = $event"
></hdi-modal>
